import React, { ReactElement, useEffect, useState } from "react";
import { InputAutocomplete } from "@components/form";
import { Link } from "react-router-dom";
import clsx from "clsx";

interface IProps {
  onChange: (
    e: React.ChangeEvent<
      HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement
    >
  ) => void;
  companyReject: () => void;
  networkingProfileCompany: any;
  userCompanyStatus: number;
  hasError?: boolean;
  editMode: boolean;
}

const Company = ({
  networkingProfileCompany,
  onChange,
  userCompanyStatus,
  hasError = false,
  editMode,
  companyReject,
}: IProps): ReactElement => {
  const hasCompany = networkingProfileCompany != null;

  const [isCompanySelected, setIsCompanySelected] = useState<boolean>(false);

  useEffect(() => {
    setIsCompanySelected(
      networkingProfileCompany?.status !== undefined && hasCompany
    );
  }, [networkingProfileCompany]);

  return (
    <>
      <div className="profile-netw-step">
        <div
          className={clsx("profile-netw-step__body", {
            "profile-netw-step--error": hasError,
          })}
        >
          <div className="profile-netw-step__body-header flex-row">
            <p
              className={`profile-netw-step__title ${
                isCompanySelected ? "" : "profile-netw-step__title--big"
              }`}
            >
              {isCompanySelected
                ? "Ваша компания"
                : "Присоединитесь к странице вашей компании"}
            </p>

            {hasCompany && editMode && (
              <div className="profile-netw-step__company-controls">
                {(userCompanyStatus === 0 ||
                  userCompanyStatus === 1 ||
                  userCompanyStatus === 2) && (
                  <button
                    className="profile-netw-step__company-action"
                    onClick={companyReject}
                  >
                    {userCompanyStatus === 0
                      ? "Отменить запрос"
                      : "Отвязать компанию"}
                  </button>
                )}
              </div>
            )}
          </div>

          {isCompanySelected ? (
            <></>
          ) : (
            <p className="profile-netw-step__desc">
              <p>
                Это <span className="underline">обязательный пункт</span>.
                Обратите внимание: название компании может быть указано на
                русском или английском языке. Попробуйте искать в двух
                вариантах.
              </p>
            </p>
          )}

          {hasCompany ? (
            <div
              className={`profile-netw-step__main ${
                isCompanySelected
                  ? "profile-netw-step__main--company"
                  : "profile-netw-step__main--company-select"
              }`}
            >
              <div className="profile-netw-step__company-image">
                {networkingProfileCompany?.companyImage !== null ? (
                  <img
                    src={networkingProfileCompany?.companyImage}
                    alt={networkingProfileCompany?.title}
                  />
                ) : (
                  <img
                    src={require("@public/images/defaultAvatarCompany.svg")}
                  />
                )}
              </div>
              <div className="profile-netw-step__company-title">
                {networkingProfileCompany.title}
              </div>
              {[0, 2].includes(userCompanyStatus) && (
                <div className="flex justify-end w-full">
                  <div
                    className={clsx("profile-netw-step__company-status", {
                      "profile-netw-step__company-status--denied":
                        userCompanyStatus === 2,
                    })}
                  >
                    {userCompanyStatus === 0 ? "На модерации" : "Отклонена"}
                  </div>
                </div>
              )}
            </div>
          ) : (
            <div className="pt-4 grid grid-cols-2 gap-6">
              <InputAutocomplete
                name="company_id"
                type="company"
                placeholder="Введите название компании"
                onSelect={onChange}
              />
              <Link
                className="profile-netw-step__company-create-link"
                to="/company/create"
              >
                Моей компании нет в списке
              </Link>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default Company;
